import { render } from "./classic.html?vue&type=template&id=71fd8566&scoped=true&external"
import script from "./ClassicPageDesktop.vue?vue&type=script&lang=js"
export * from "./ClassicPageDesktop.vue?vue&type=script&lang=js"

import "./style-pc-default.css?vue&type=style&index=0&id=71fd8566&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fd8566"]])

export default __exports__